// src/auth/RequierePlan.tsx
//
// Guard de ruta para el panel de empresa: deja pasar solo si la empresa
// tiene plan efectivo activo (ver useAccesoEmpresa). Se usa como ruta
// envolvente (con <Outlet/>) alrededor de las pantallas de operativa —
// las de Suscripción y Perfil quedan FUERA de este guard, siempre
// accesibles, para que quien no tenga plan pueda entrar a contratarlo.
//
// Solo controla la navegación (UX). La protección de los datos debe
// reforzarse en las RLS de Supabase.

import { Navigate, Outlet } from 'react-router-dom';
import { useAccesoEmpresa } from '@/components/hooks/useAccesoEmpresa';
import PanelSkeleton from '@/components/pages/shared/PanelSkeleton';

export default function RequierePlan() {
  const { cargando, tieneAcceso } = useAccesoEmpresa();

  // Mientras se comprueba el acceso, un esqueleto con la forma del panel
  // (menos brusco que un spinner y evita el parpadeo de contenido).
  if (cargando) {
    return <PanelSkeleton />;
  }

  // Sin plan efectivo → a la pantalla de plan requerido, no a la operativa.
  if (!tieneAcceso) {
    return <Navigate to="/panel-empresa/plan-requerido" replace />;
  }

  return <Outlet />;
}